module.exports = __webpack_public_path__ + "static/ALLEGATO31-d4a7f1abb86c5ec52f25b93af5bc3073.pdf";